// Common airports list for travel bookings
export interface Airport {
  code: string;
  name: string;
  city: string;
  country: string;
}

export const AIRPORTS: Airport[] = [
  // Turkey - All Commercial Airports
  { code: 'IST', name: 'Istanbul Airport', city: 'Istanbul', country: 'TR' },
  { code: 'SAW', name: 'Sabiha Gökçen', city: 'Istanbul', country: 'TR' },
  { code: 'AYT', name: 'Antalya Airport', city: 'Antalya', country: 'TR' },
  { code: 'ESB', name: 'Esenboğa Airport', city: 'Ankara', country: 'TR' },
  { code: 'ADB', name: 'Adnan Menderes', city: 'Izmir', country: 'TR' },
  { code: 'DLM', name: 'Dalaman Airport', city: 'Dalaman', country: 'TR' },
  { code: 'BJV', name: 'Milas-Bodrum Airport', city: 'Bodrum', country: 'TR' },
  { code: 'GZT', name: 'Gaziantep Airport', city: 'Gaziantep', country: 'TR' },
  { code: 'TZX', name: 'Trabzon Airport', city: 'Trabzon', country: 'TR' },
  { code: 'VAN', name: 'Ferit Melen Airport', city: 'Van', country: 'TR' },
  { code: 'ERZ', name: 'Erzurum Airport', city: 'Erzurum', country: 'TR' },
  { code: 'KYA', name: 'Konya Airport', city: 'Konya', country: 'TR' },
  { code: 'ASR', name: 'Kayseri Airport', city: 'Kayseri', country: 'TR' },
  { code: 'SZF', name: 'Samsun-Çarşamba', city: 'Samsun', country: 'TR' },
  { code: 'DNZ', name: 'Çardak Airport', city: 'Denizli', country: 'TR' },
  { code: 'ADA', name: 'Adana Airport', city: 'Adana', country: 'TR' },
  { code: 'GNY', name: 'Şanlıurfa GAP', city: 'Şanlıurfa', country: 'TR' },
  { code: 'DIY', name: 'Diyarbakır Airport', city: 'Diyarbakır', country: 'TR' },
  { code: 'MLX', name: 'Malatya Airport', city: 'Malatya', country: 'TR' },
  { code: 'EZS', name: 'Elazığ Airport', city: 'Elazığ', country: 'TR' },
  { code: 'MQM', name: 'Mardin Airport', city: 'Mardin', country: 'TR' },
  { code: 'NOP', name: 'Sinop Airport', city: 'Sinop', country: 'TR' },
  { code: 'KCM', name: 'Kahramanmaraş Airport', city: 'Kahramanmaraş', country: 'TR' },
  { code: 'HTY', name: 'Hatay Airport', city: 'Hatay', country: 'TR' },
  { code: 'NAV', name: 'Nevşehir Kapadokya', city: 'Nevşehir', country: 'TR' },
  { code: 'OGU', name: 'Ordu-Giresun Airport', city: 'Ordu', country: 'TR' },
  { code: 'KZR', name: 'Zafer Airport', city: 'Kütahya', country: 'TR' },
  { code: 'TEQ', name: 'Tekirdağ Çorlu', city: 'Tekirdağ', country: 'TR' },
  { code: 'CKZ', name: 'Çanakkale Airport', city: 'Çanakkale', country: 'TR' },
  { code: 'BZI', name: 'Balıkesir Airport', city: 'Balıkesir', country: 'TR' },
  { code: 'EDO', name: 'Balıkesir Koca Seyit', city: 'Edremit', country: 'TR' },
  { code: 'USQ', name: 'Uşak Airport', city: 'Uşak', country: 'TR' },
  { code: 'AFY', name: 'Afyon Airport', city: 'Afyonkarahisar', country: 'TR' },
  { code: 'ISE', name: 'Isparta Airport', city: 'Isparta', country: 'TR' },
  { code: 'KFS', name: 'Kastamonu Airport', city: 'Kastamonu', country: 'TR' },
  { code: 'AOE', name: 'Anadolu Airport', city: 'Eskişehir', country: 'TR' },
  { code: 'YEI', name: 'Bursa Yenişehir', city: 'Bursa', country: 'TR' },
  { code: 'SIC', name: 'Siirt Airport', city: 'Siirt', country: 'TR' },
  { code: 'NKT', name: 'Şırnak Airport', city: 'Şırnak', country: 'TR' },
  { code: 'IGD', name: 'Iğdır Airport', city: 'Iğdır', country: 'TR' },
  { code: 'MSR', name: 'Muş Airport', city: 'Muş', country: 'TR' },
  { code: 'BGG', name: 'Bingöl Airport', city: 'Bingöl', country: 'TR' },
  { code: 'KSY', name: 'Kars Airport', city: 'Kars', country: 'TR' },
  { code: 'AJI', name: 'Ağrı Airport', city: 'Ağrı', country: 'TR' },
  { code: 'BAL', name: 'Batman Airport', city: 'Batman', country: 'TR' },
  { code: 'VAS', name: 'Sivas Airport', city: 'Sivas', country: 'TR' },
  { code: 'ONQ', name: 'Zonguldak Airport', city: 'Zonguldak', country: 'TR' },
  { code: 'TJK', name: 'Tokat Airport', city: 'Tokat', country: 'TR' },
  { code: 'GKD', name: 'Gökçeada Airport', city: 'Gökçeada', country: 'TR' },
  { code: 'BXN', name: 'Bodrum-Imsik Airport', city: 'Bodrum', country: 'TR' },
  { code: 'HRK', name: 'Hakkari Yüksekova', city: 'Hakkari', country: 'TR' },

  // Cyprus
  { code: 'ECN', name: 'Ercan Airport', city: 'Lefkoşa', country: 'CY' },
  { code: 'LCA', name: 'Larnaca Airport', city: 'Larnaca', country: 'CY' },
  { code: 'PFO', name: 'Paphos Airport', city: 'Paphos', country: 'CY' },

  // Greece
  { code: 'ATH', name: 'Eleftherios Venizelos', city: 'Athens', country: 'GR' },
  { code: 'SKG', name: 'Thessaloniki Airport', city: 'Thessaloniki', country: 'GR' },
  { code: 'HER', name: 'Heraklion Airport', city: 'Heraklion', country: 'GR' },
  { code: 'RHO', name: 'Rhodes Airport', city: 'Rhodes', country: 'GR' },
  { code: 'CHQ', name: 'Chania Airport', city: 'Chania', country: 'GR' },
  { code: 'CFU', name: 'Corfu Airport', city: 'Corfu', country: 'GR' },
  { code: 'KGS', name: 'Kos Airport', city: 'Kos', country: 'GR' },
  { code: 'JTR', name: 'Santorini Airport', city: 'Santorini', country: 'GR' },
  { code: 'JMK', name: 'Mykonos Airport', city: 'Mykonos', country: 'GR' },
  { code: 'ZTH', name: 'Zakynthos Airport', city: 'Zakynthos', country: 'GR' },
  { code: 'EFL', name: 'Kefalonia Airport', city: 'Kefalonia', country: 'GR' },
  { code: 'PVK', name: 'Preveza Airport', city: 'Preveza', country: 'GR' },
  { code: 'KVA', name: 'Kavala Airport', city: 'Kavala', country: 'GR' },
  { code: 'SMI', name: 'Samos Airport', city: 'Samos', country: 'GR' },
  { code: 'JKH', name: 'Chios Airport', city: 'Chios', country: 'GR' },
  { code: 'MJT', name: 'Mytilene Airport', city: 'Mytilene', country: 'GR' },
  { code: 'VOL', name: 'Volos Airport', city: 'Volos', country: 'GR' },
  { code: 'IOA', name: 'Ioannina Airport', city: 'Ioannina', country: 'GR' },
  { code: 'SKU', name: 'Skiathos Airport', city: 'Skiathos', country: 'GR' },

  // United Kingdom
  { code: 'LHR', name: 'Heathrow Airport', city: 'London', country: 'GB' },
  { code: 'LGW', name: 'Gatwick Airport', city: 'London', country: 'GB' },
  { code: 'STN', name: 'Stansted Airport', city: 'London', country: 'GB' },
  { code: 'LTN', name: 'Luton Airport', city: 'London', country: 'GB' },
  { code: 'LCY', name: 'London City Airport', city: 'London', country: 'GB' },
  { code: 'MAN', name: 'Manchester Airport', city: 'Manchester', country: 'GB' },
  { code: 'BHX', name: 'Birmingham Airport', city: 'Birmingham', country: 'GB' },
  { code: 'EDI', name: 'Edinburgh Airport', city: 'Edinburgh', country: 'GB' },
  { code: 'GLA', name: 'Glasgow Airport', city: 'Glasgow', country: 'GB' },
  { code: 'BRS', name: 'Bristol Airport', city: 'Bristol', country: 'GB' },
  { code: 'NCL', name: 'Newcastle Airport', city: 'Newcastle', country: 'GB' },
  { code: 'LPL', name: 'Liverpool Airport', city: 'Liverpool', country: 'GB' },
  { code: 'EMA', name: 'East Midlands Airport', city: 'Nottingham', country: 'GB' },
  { code: 'LBA', name: 'Leeds Bradford', city: 'Leeds', country: 'GB' },
  { code: 'BFS', name: 'Belfast International', city: 'Belfast', country: 'GB' },
  { code: 'CWL', name: 'Cardiff Airport', city: 'Cardiff', country: 'GB' },
  { code: 'ABZ', name: 'Aberdeen Airport', city: 'Aberdeen', country: 'GB' },
  { code: 'SOU', name: 'Southampton Airport', city: 'Southampton', country: 'GB' },

  // Germany
  { code: 'FRA', name: 'Frankfurt Airport', city: 'Frankfurt', country: 'DE' },
  { code: 'MUC', name: 'Munich Airport', city: 'Munich', country: 'DE' },
  { code: 'BER', name: 'Berlin Brandenburg', city: 'Berlin', country: 'DE' },
  { code: 'DUS', name: 'Düsseldorf Airport', city: 'Düsseldorf', country: 'DE' },
  { code: 'HAM', name: 'Hamburg Airport', city: 'Hamburg', country: 'DE' },
  { code: 'CGN', name: 'Cologne Bonn Airport', city: 'Cologne', country: 'DE' },
  { code: 'STR', name: 'Stuttgart Airport', city: 'Stuttgart', country: 'DE' },
  { code: 'HAJ', name: 'Hannover Airport', city: 'Hannover', country: 'DE' },
  { code: 'NUE', name: 'Nuremberg Airport', city: 'Nuremberg', country: 'DE' },
  { code: 'LEJ', name: 'Leipzig Airport', city: 'Leipzig', country: 'DE' },
  { code: 'DRS', name: 'Dresden Airport', city: 'Dresden', country: 'DE' },
  { code: 'BRE', name: 'Bremen Airport', city: 'Bremen', country: 'DE' },
  { code: 'DTM', name: 'Dortmund Airport', city: 'Dortmund', country: 'DE' },
  { code: 'FMO', name: 'Münster Airport', city: 'Münster', country: 'DE' },
  { code: 'PAD', name: 'Paderborn Airport', city: 'Paderborn', country: 'DE' },

  // France
  { code: 'CDG', name: 'Charles de Gaulle', city: 'Paris', country: 'FR' },
  { code: 'ORY', name: 'Orly Airport', city: 'Paris', country: 'FR' },
  { code: 'NCE', name: 'Nice Côte d\'Azur', city: 'Nice', country: 'FR' },
  { code: 'LYS', name: 'Lyon Airport', city: 'Lyon', country: 'FR' },
  { code: 'MRS', name: 'Marseille Airport', city: 'Marseille', country: 'FR' },
  { code: 'TLS', name: 'Toulouse Airport', city: 'Toulouse', country: 'FR' },
  { code: 'BOD', name: 'Bordeaux Airport', city: 'Bordeaux', country: 'FR' },
  { code: 'NTE', name: 'Nantes Airport', city: 'Nantes', country: 'FR' },
  { code: 'SXB', name: 'Strasbourg Airport', city: 'Strasbourg', country: 'FR' },
  { code: 'MPL', name: 'Montpellier Airport', city: 'Montpellier', country: 'FR' },
  { code: 'BIQ', name: 'Biarritz Airport', city: 'Biarritz', country: 'FR' },
  { code: 'LIL', name: 'Lille Airport', city: 'Lille', country: 'FR' },
  { code: 'RNS', name: 'Rennes Airport', city: 'Rennes', country: 'FR' },
  { code: 'AJA', name: 'Ajaccio Airport', city: 'Ajaccio', country: 'FR' },
  { code: 'BIA', name: 'Bastia Airport', city: 'Bastia', country: 'FR' },

  // Netherlands
  { code: 'AMS', name: 'Schiphol Airport', city: 'Amsterdam', country: 'NL' },
  { code: 'EIN', name: 'Eindhoven Airport', city: 'Eindhoven', country: 'NL' },
  { code: 'RTM', name: 'Rotterdam Airport', city: 'Rotterdam', country: 'NL' },
  { code: 'MST', name: 'Maastricht Airport', city: 'Maastricht', country: 'NL' },
  { code: 'GRQ', name: 'Groningen Airport', city: 'Groningen', country: 'NL' },

  // Belgium
  { code: 'BRU', name: 'Brussels Airport', city: 'Brussels', country: 'BE' },
  { code: 'CRL', name: 'Brussels South Charleroi', city: 'Charleroi', country: 'BE' },
  { code: 'ANR', name: 'Antwerp Airport', city: 'Antwerp', country: 'BE' },
  { code: 'LGG', name: 'Liège Airport', city: 'Liège', country: 'BE' },
  { code: 'OST', name: 'Ostend Airport', city: 'Ostend', country: 'BE' },

  // Spain
  { code: 'MAD', name: 'Barajas Airport', city: 'Madrid', country: 'ES' },
  { code: 'BCN', name: 'El Prat Airport', city: 'Barcelona', country: 'ES' },
  { code: 'PMI', name: 'Palma de Mallorca', city: 'Palma', country: 'ES' },
  { code: 'AGP', name: 'Málaga Airport', city: 'Málaga', country: 'ES' },
  { code: 'ALC', name: 'Alicante Airport', city: 'Alicante', country: 'ES' },
  { code: 'VLC', name: 'Valencia Airport', city: 'Valencia', country: 'ES' },
  { code: 'SVQ', name: 'Seville Airport', city: 'Seville', country: 'ES' },
  { code: 'BIO', name: 'Bilbao Airport', city: 'Bilbao', country: 'ES' },
  { code: 'TFS', name: 'Tenerife South', city: 'Tenerife', country: 'ES' },
  { code: 'TFN', name: 'Tenerife North', city: 'Tenerife', country: 'ES' },
  { code: 'LPA', name: 'Gran Canaria Airport', city: 'Las Palmas', country: 'ES' },
  { code: 'IBZ', name: 'Ibiza Airport', city: 'Ibiza', country: 'ES' },
  { code: 'FUE', name: 'Fuerteventura Airport', city: 'Fuerteventura', country: 'ES' },
  { code: 'ACE', name: 'Lanzarote Airport', city: 'Lanzarote', country: 'ES' },
  { code: 'MAH', name: 'Menorca Airport', city: 'Menorca', country: 'ES' },
  { code: 'GRX', name: 'Granada Airport', city: 'Granada', country: 'ES' },
  { code: 'SDR', name: 'Santander Airport', city: 'Santander', country: 'ES' },
  { code: 'SCQ', name: 'Santiago Airport', city: 'Santiago', country: 'ES' },
  { code: 'OVD', name: 'Asturias Airport', city: 'Oviedo', country: 'ES' },
  { code: 'REU', name: 'Reus Airport', city: 'Reus', country: 'ES' },
  { code: 'XRY', name: 'Jerez Airport', city: 'Jerez', country: 'ES' },
  { code: 'ZAZ', name: 'Zaragoza Airport', city: 'Zaragoza', country: 'ES' },
  { code: 'MJV', name: 'Murcia Airport', city: 'Murcia', country: 'ES' },

  // Portugal
  { code: 'LIS', name: 'Lisbon Airport', city: 'Lisbon', country: 'PT' },
  { code: 'OPO', name: 'Porto Airport', city: 'Porto', country: 'PT' },
  { code: 'FAO', name: 'Faro Airport', city: 'Faro', country: 'PT' },
  { code: 'FNC', name: 'Madeira Airport', city: 'Funchal', country: 'PT' },
  { code: 'PDL', name: 'Ponta Delgada', city: 'Ponta Delgada', country: 'PT' },

  // Italy
  { code: 'FCO', name: 'Fiumicino Airport', city: 'Rome', country: 'IT' },
  { code: 'CIA', name: 'Ciampino Airport', city: 'Rome', country: 'IT' },
  { code: 'MXP', name: 'Malpensa Airport', city: 'Milan', country: 'IT' },
  { code: 'LIN', name: 'Linate Airport', city: 'Milan', country: 'IT' },
  { code: 'BGY', name: 'Bergamo Airport', city: 'Bergamo', country: 'IT' },
  { code: 'VCE', name: 'Marco Polo Airport', city: 'Venice', country: 'IT' },
  { code: 'TSF', name: 'Treviso Airport', city: 'Treviso', country: 'IT' },
  { code: 'NAP', name: 'Naples Airport', city: 'Naples', country: 'IT' },
  { code: 'BLQ', name: 'Bologna Airport', city: 'Bologna', country: 'IT' },
  { code: 'FLR', name: 'Florence Airport', city: 'Florence', country: 'IT' },
  { code: 'PSA', name: 'Pisa Airport', city: 'Pisa', country: 'IT' },
  { code: 'CTA', name: 'Catania Airport', city: 'Catania', country: 'IT' },
  { code: 'PMO', name: 'Palermo Airport', city: 'Palermo', country: 'IT' },
  { code: 'CAG', name: 'Cagliari Airport', city: 'Cagliari', country: 'IT' },
  { code: 'OLB', name: 'Olbia Airport', city: 'Olbia', country: 'IT' },
  { code: 'TRN', name: 'Turin Airport', city: 'Turin', country: 'IT' },
  { code: 'GOA', name: 'Genoa Airport', city: 'Genoa', country: 'IT' },
  { code: 'VRN', name: 'Verona Airport', city: 'Verona', country: 'IT' },
  { code: 'TRS', name: 'Trieste Airport', city: 'Trieste', country: 'IT' },
  { code: 'BRI', name: 'Bari Airport', city: 'Bari', country: 'IT' },
  { code: 'BDS', name: 'Brindisi Airport', city: 'Brindisi', country: 'IT' },
  { code: 'SUF', name: 'Lamezia Terme', city: 'Lamezia Terme', country: 'IT' },
  { code: 'REG', name: 'Reggio Calabria', city: 'Reggio Calabria', country: 'IT' },
  { code: 'AHO', name: 'Alghero Airport', city: 'Alghero', country: 'IT' },
  { code: 'TPS', name: 'Trapani Airport', city: 'Trapani', country: 'IT' },
  { code: 'CRV', name: 'Crotone Airport', city: 'Crotone', country: 'IT' },
  { code: 'PEG', name: 'Perugia Airport', city: 'Perugia', country: 'IT' },
  { code: 'AOI', name: 'Ancona Airport', city: 'Ancona', country: 'IT' },

  // Switzerland
  { code: 'ZRH', name: 'Zurich Airport', city: 'Zurich', country: 'CH' },
  { code: 'GVA', name: 'Geneva Airport', city: 'Geneva', country: 'CH' },
  { code: 'BSL', name: 'Basel Airport', city: 'Basel', country: 'CH' },
  { code: 'BRN', name: 'Bern Airport', city: 'Bern', country: 'CH' },
  { code: 'LUG', name: 'Lugano Airport', city: 'Lugano', country: 'CH' },

  // Austria
  { code: 'VIE', name: 'Vienna Airport', city: 'Vienna', country: 'AT' },
  { code: 'SZG', name: 'Salzburg Airport', city: 'Salzburg', country: 'AT' },
  { code: 'INN', name: 'Innsbruck Airport', city: 'Innsbruck', country: 'AT' },
  { code: 'GRZ', name: 'Graz Airport', city: 'Graz', country: 'AT' },
  { code: 'LNZ', name: 'Linz Airport', city: 'Linz', country: 'AT' },
  { code: 'KLU', name: 'Klagenfurt Airport', city: 'Klagenfurt', country: 'AT' },

  // Czech Republic
  { code: 'PRG', name: 'Václav Havel Airport', city: 'Prague', country: 'CZ' },
  { code: 'BRQ', name: 'Brno Airport', city: 'Brno', country: 'CZ' },
  { code: 'OSR', name: 'Ostrava Airport', city: 'Ostrava', country: 'CZ' },
  { code: 'KLV', name: 'Karlovy Vary Airport', city: 'Karlovy Vary', country: 'CZ' },

  // Poland
  { code: 'WAW', name: 'Chopin Airport', city: 'Warsaw', country: 'PL' },
  { code: 'WMI', name: 'Warsaw Modlin', city: 'Warsaw', country: 'PL' },
  { code: 'KRK', name: 'Krakow Airport', city: 'Krakow', country: 'PL' },
  { code: 'GDN', name: 'Gdańsk Airport', city: 'Gdańsk', country: 'PL' },
  { code: 'WRO', name: 'Wrocław Airport', city: 'Wrocław', country: 'PL' },
  { code: 'POZ', name: 'Poznań Airport', city: 'Poznań', country: 'PL' },
  { code: 'KTW', name: 'Katowice Airport', city: 'Katowice', country: 'PL' },
  { code: 'RZE', name: 'Rzeszów Airport', city: 'Rzeszów', country: 'PL' },
  { code: 'SZZ', name: 'Szczecin Airport', city: 'Szczecin', country: 'PL' },
  { code: 'LUZ', name: 'Lublin Airport', city: 'Lublin', country: 'PL' },
  { code: 'BZG', name: 'Bydgoszcz Airport', city: 'Bydgoszcz', country: 'PL' },
  { code: 'LCJ', name: 'Łódź Airport', city: 'Łódź', country: 'PL' },

  // Hungary
  { code: 'BUD', name: 'Budapest Airport', city: 'Budapest', country: 'HU' },
  { code: 'DEB', name: 'Debrecen Airport', city: 'Debrecen', country: 'HU' },

  // Romania
  { code: 'OTP', name: 'Bucharest Otopeni', city: 'Bucharest', country: 'RO' },
  { code: 'BBU', name: 'Bucharest Băneasa', city: 'Bucharest', country: 'RO' },
  { code: 'CLJ', name: 'Cluj-Napoca Airport', city: 'Cluj-Napoca', country: 'RO' },
  { code: 'TSR', name: 'Timișoara Airport', city: 'Timișoara', country: 'RO' },
  { code: 'IAS', name: 'Iași Airport', city: 'Iași', country: 'RO' },
  { code: 'SBZ', name: 'Sibiu Airport', city: 'Sibiu', country: 'RO' },
  { code: 'CND', name: 'Constanța Airport', city: 'Constanța', country: 'RO' },
  { code: 'CRA', name: 'Craiova Airport', city: 'Craiova', country: 'RO' },
  { code: 'OMR', name: 'Oradea Airport', city: 'Oradea', country: 'RO' },
  { code: 'SUJ', name: 'Satu Mare Airport', city: 'Satu Mare', country: 'RO' },
  { code: 'TGM', name: 'Târgu Mureș Airport', city: 'Târgu Mureș', country: 'RO' },
  { code: 'BCM', name: 'Bacău Airport', city: 'Bacău', country: 'RO' },

  // Bulgaria
  { code: 'SOF', name: 'Sofia Airport', city: 'Sofia', country: 'BG' },
  { code: 'BOJ', name: 'Burgas Airport', city: 'Burgas', country: 'BG' },
  { code: 'VAR', name: 'Varna Airport', city: 'Varna', country: 'BG' },
  { code: 'PDV', name: 'Plovdiv Airport', city: 'Plovdiv', country: 'BG' },

  // Croatia
  { code: 'ZAG', name: 'Zagreb Airport', city: 'Zagreb', country: 'HR' },
  { code: 'SPU', name: 'Split Airport', city: 'Split', country: 'HR' },
  { code: 'DBV', name: 'Dubrovnik Airport', city: 'Dubrovnik', country: 'HR' },
  { code: 'ZAD', name: 'Zadar Airport', city: 'Zadar', country: 'HR' },
  { code: 'PUY', name: 'Pula Airport', city: 'Pula', country: 'HR' },
  { code: 'RJK', name: 'Rijeka Airport', city: 'Rijeka', country: 'HR' },
  { code: 'OSI', name: 'Osijek Airport', city: 'Osijek', country: 'HR' },

  // Serbia
  { code: 'BEG', name: 'Belgrade Airport', city: 'Belgrade', country: 'RS' },
  { code: 'INI', name: 'Niš Airport', city: 'Niš', country: 'RS' },

  // Slovenia
  { code: 'LJU', name: 'Ljubljana Airport', city: 'Ljubljana', country: 'SI' },
  { code: 'MBX', name: 'Maribor Airport', city: 'Maribor', country: 'SI' },

  // Bosnia and Herzegovina
  { code: 'SJJ', name: 'Sarajevo Airport', city: 'Sarajevo', country: 'BA' },
  { code: 'TZL', name: 'Tuzla Airport', city: 'Tuzla', country: 'BA' },
  { code: 'BNX', name: 'Banja Luka Airport', city: 'Banja Luka', country: 'BA' },
  { code: 'OMO', name: 'Mostar Airport', city: 'Mostar', country: 'BA' },

  // Montenegro
  { code: 'TGD', name: 'Podgorica Airport', city: 'Podgorica', country: 'ME' },
  { code: 'TIV', name: 'Tivat Airport', city: 'Tivat', country: 'ME' },

  // North Macedonia
  { code: 'SKP', name: 'Skopje Airport', city: 'Skopje', country: 'MK' },
  { code: 'OHD', name: 'Ohrid Airport', city: 'Ohrid', country: 'MK' },

  // Albania
  { code: 'TIA', name: 'Tirana Airport', city: 'Tirana', country: 'AL' },

  // Kosovo
  { code: 'PRN', name: 'Pristina Airport', city: 'Pristina', country: 'XK' },

  // Scandinavia
  { code: 'CPH', name: 'Copenhagen Airport', city: 'Copenhagen', country: 'DK' },
  { code: 'BLL', name: 'Billund Airport', city: 'Billund', country: 'DK' },
  { code: 'AAL', name: 'Aalborg Airport', city: 'Aalborg', country: 'DK' },
  { code: 'OSL', name: 'Gardermoen Airport', city: 'Oslo', country: 'NO' },
  { code: 'BGO', name: 'Bergen Airport', city: 'Bergen', country: 'NO' },
  { code: 'TRD', name: 'Trondheim Airport', city: 'Trondheim', country: 'NO' },
  { code: 'SVG', name: 'Stavanger Airport', city: 'Stavanger', country: 'NO' },
  { code: 'TOS', name: 'Tromsø Airport', city: 'Tromsø', country: 'NO' },
  { code: 'ARN', name: 'Arlanda Airport', city: 'Stockholm', country: 'SE' },
  { code: 'NYO', name: 'Stockholm Skavsta', city: 'Stockholm', country: 'SE' },
  { code: 'GOT', name: 'Gothenburg Airport', city: 'Gothenburg', country: 'SE' },
  { code: 'MMX', name: 'Malmö Airport', city: 'Malmö', country: 'SE' },
  { code: 'HEL', name: 'Helsinki Airport', city: 'Helsinki', country: 'FI' },
  { code: 'TMP', name: 'Tampere Airport', city: 'Tampere', country: 'FI' },
  { code: 'TKU', name: 'Turku Airport', city: 'Turku', country: 'FI' },
  { code: 'OUL', name: 'Oulu Airport', city: 'Oulu', country: 'FI' },
  { code: 'RVN', name: 'Rovaniemi Airport', city: 'Rovaniemi', country: 'FI' },
  { code: 'KEF', name: 'Keflavík Airport', city: 'Reykjavik', country: 'IS' },

  // Ireland
  { code: 'DUB', name: 'Dublin Airport', city: 'Dublin', country: 'IE' },
  { code: 'ORK', name: 'Cork Airport', city: 'Cork', country: 'IE' },
  { code: 'SNN', name: 'Shannon Airport', city: 'Shannon', country: 'IE' },
  { code: 'KIR', name: 'Kerry Airport', city: 'Kerry', country: 'IE' },
  { code: 'NOC', name: 'Knock Airport', city: 'Knock', country: 'IE' },

  // Baltic States
  { code: 'TLL', name: 'Tallinn Airport', city: 'Tallinn', country: 'EE' },
  { code: 'RIX', name: 'Riga Airport', city: 'Riga', country: 'LV' },
  { code: 'VNO', name: 'Vilnius Airport', city: 'Vilnius', country: 'LT' },
  { code: 'KUN', name: 'Kaunas Airport', city: 'Kaunas', country: 'LT' },
  { code: 'PLQ', name: 'Palanga Airport', city: 'Palanga', country: 'LT' },

  // Ukraine
  { code: 'KBP', name: 'Boryspil Airport', city: 'Kyiv', country: 'UA' },
  { code: 'IEV', name: 'Zhuliany Airport', city: 'Kyiv', country: 'UA' },
  { code: 'LWO', name: 'Lviv Airport', city: 'Lviv', country: 'UA' },
  { code: 'ODS', name: 'Odesa Airport', city: 'Odesa', country: 'UA' },
  { code: 'HRK', name: 'Kharkiv Airport', city: 'Kharkiv', country: 'UA' },
  { code: 'DNK', name: 'Dnipro Airport', city: 'Dnipro', country: 'UA' },

  // Moldova
  { code: 'KIV', name: 'Chișinău Airport', city: 'Chișinău', country: 'MD' },

  // Malta
  { code: 'MLA', name: 'Malta Airport', city: 'Valletta', country: 'MT' },

  // Luxembourg
  { code: 'LUX', name: 'Luxembourg Airport', city: 'Luxembourg', country: 'LU' },

  // Monaco (uses Nice)
  // Andorra (uses Barcelona/Toulouse)
  // San Marino (uses Bologna/Rimini)
  // Vatican (uses Rome)
  // Liechtenstein (uses Zurich)

  // Middle East
  { code: 'DXB', name: 'Dubai International', city: 'Dubai', country: 'AE' },
  { code: 'AUH', name: 'Abu Dhabi Airport', city: 'Abu Dhabi', country: 'AE' },
  { code: 'SHJ', name: 'Sharjah Airport', city: 'Sharjah', country: 'AE' },
  { code: 'DWC', name: 'Al Maktoum Airport', city: 'Dubai', country: 'AE' },
  { code: 'RKT', name: 'Ras Al Khaimah', city: 'Ras Al Khaimah', country: 'AE' },
  { code: 'DOH', name: 'Hamad International', city: 'Doha', country: 'QA' },
  { code: 'RUH', name: 'King Khalid Airport', city: 'Riyadh', country: 'SA' },
  { code: 'JED', name: 'King Abdulaziz', city: 'Jeddah', country: 'SA' },
  { code: 'DMM', name: 'King Fahd Airport', city: 'Dammam', country: 'SA' },
  { code: 'MED', name: 'Prince Mohammad Airport', city: 'Medina', country: 'SA' },
  { code: 'TLV', name: 'Ben Gurion Airport', city: 'Tel Aviv', country: 'IL' },
  { code: 'AMM', name: 'Queen Alia Airport', city: 'Amman', country: 'JO' },
  { code: 'AQJ', name: 'Aqaba Airport', city: 'Aqaba', country: 'JO' },
  { code: 'BAH', name: 'Bahrain Airport', city: 'Manama', country: 'BH' },
  { code: 'KWI', name: 'Kuwait Airport', city: 'Kuwait City', country: 'KW' },
  { code: 'MCT', name: 'Muscat Airport', city: 'Muscat', country: 'OM' },
  { code: 'SLL', name: 'Salalah Airport', city: 'Salalah', country: 'OM' },
  { code: 'BEY', name: 'Beirut Airport', city: 'Beirut', country: 'LB' },
  { code: 'BGW', name: 'Baghdad Airport', city: 'Baghdad', country: 'IQ' },
  { code: 'BSR', name: 'Basra Airport', city: 'Basra', country: 'IQ' },
  { code: 'EBL', name: 'Erbil Airport', city: 'Erbil', country: 'IQ' },
  { code: 'NJF', name: 'Najaf Airport', city: 'Najaf', country: 'IQ' },
  { code: 'ISU', name: 'Sulaymaniyah Airport', city: 'Sulaymaniyah', country: 'IQ' },

  // Iran
  { code: 'IKA', name: 'Imam Khomeini Airport', city: 'Tehran', country: 'IR' },
  { code: 'THR', name: 'Mehrabad Airport', city: 'Tehran', country: 'IR' },
  { code: 'MHD', name: 'Mashhad Airport', city: 'Mashhad', country: 'IR' },
  { code: 'SYZ', name: 'Shiraz Airport', city: 'Shiraz', country: 'IR' },
  { code: 'TBZ', name: 'Tabriz Airport', city: 'Tabriz', country: 'IR' },
  { code: 'KIH', name: 'Kish Island Airport', city: 'Kish Island', country: 'IR' },
  { code: 'AWZ', name: 'Ahvaz Airport', city: 'Ahvaz', country: 'IR' },

  // Egypt
  { code: 'CAI', name: 'Cairo International', city: 'Cairo', country: 'EG' },
  { code: 'HRG', name: 'Hurghada Airport', city: 'Hurghada', country: 'EG' },
  { code: 'SSH', name: 'Sharm el-Sheikh', city: 'Sharm el-Sheikh', country: 'EG' },
  { code: 'LXR', name: 'Luxor Airport', city: 'Luxor', country: 'EG' },
  { code: 'ASW', name: 'Aswan Airport', city: 'Aswan', country: 'EG' },
  { code: 'HBE', name: 'Borg El Arab', city: 'Alexandria', country: 'EG' },
  { code: 'RMF', name: 'Marsa Alam Airport', city: 'Marsa Alam', country: 'EG' },
  { code: 'SPX', name: 'Sphinx International', city: 'Cairo', country: 'EG' },

  // North Africa
  { code: 'CMN', name: 'Mohammed V Airport', city: 'Casablanca', country: 'MA' },
  { code: 'RAK', name: 'Marrakech Airport', city: 'Marrakech', country: 'MA' },
  { code: 'AGA', name: 'Agadir Airport', city: 'Agadir', country: 'MA' },
  { code: 'FEZ', name: 'Fès Airport', city: 'Fès', country: 'MA' },
  { code: 'TNG', name: 'Tangier Airport', city: 'Tangier', country: 'MA' },
  { code: 'RBA', name: 'Rabat Airport', city: 'Rabat', country: 'MA' },
  { code: 'NDR', name: 'Nador Airport', city: 'Nador', country: 'MA' },
  { code: 'OUD', name: 'Oujda Airport', city: 'Oujda', country: 'MA' },
  { code: 'ALG', name: 'Houari Boumediene', city: 'Algiers', country: 'DZ' },
  { code: 'ORN', name: 'Oran Airport', city: 'Oran', country: 'DZ' },
  { code: 'CZL', name: 'Constantine Airport', city: 'Constantine', country: 'DZ' },
  { code: 'TUN', name: 'Tunis-Carthage', city: 'Tunis', country: 'TN' },
  { code: 'DJE', name: 'Djerba Airport', city: 'Djerba', country: 'TN' },
  { code: 'MIR', name: 'Monastir Airport', city: 'Monastir', country: 'TN' },
  { code: 'NBE', name: 'Enfidha Airport', city: 'Enfidha', country: 'TN' },
  { code: 'SFA', name: 'Sfax Airport', city: 'Sfax', country: 'TN' },
  { code: 'TIP', name: 'Tripoli Airport', city: 'Tripoli', country: 'LY' },
  { code: 'BEN', name: 'Benghazi Airport', city: 'Benghazi', country: 'LY' },

  // Sub-Saharan Africa
  { code: 'JNB', name: 'O.R. Tambo Airport', city: 'Johannesburg', country: 'ZA' },
  { code: 'CPT', name: 'Cape Town Airport', city: 'Cape Town', country: 'ZA' },
  { code: 'DUR', name: 'King Shaka Airport', city: 'Durban', country: 'ZA' },
  { code: 'NBO', name: 'Jomo Kenyatta', city: 'Nairobi', country: 'KE' },
  { code: 'MBA', name: 'Moi International', city: 'Mombasa', country: 'KE' },
  { code: 'ADD', name: 'Bole Airport', city: 'Addis Ababa', country: 'ET' },
  { code: 'LOS', name: 'Murtala Muhammed', city: 'Lagos', country: 'NG' },
  { code: 'ABV', name: 'Nnamdi Azikiwe', city: 'Abuja', country: 'NG' },
  { code: 'ACC', name: 'Kotoka Airport', city: 'Accra', country: 'GH' },
  { code: 'DSS', name: 'Blaise Diagne', city: 'Dakar', country: 'SN' },
  { code: 'ABJ', name: 'Félix Houphouët', city: 'Abidjan', country: 'CI' },
  { code: 'DAR', name: 'Julius Nyerere', city: 'Dar es Salaam', country: 'TZ' },
  { code: 'ZNZ', name: 'Zanzibar Airport', city: 'Zanzibar', country: 'TZ' },
  { code: 'JRO', name: 'Kilimanjaro Airport', city: 'Kilimanjaro', country: 'TZ' },
  { code: 'EBB', name: 'Entebbe Airport', city: 'Entebbe', country: 'UG' },
  { code: 'KGL', name: 'Kigali Airport', city: 'Kigali', country: 'RW' },
  { code: 'MRU', name: 'Mauritius Airport', city: 'Port Louis', country: 'MU' },
  { code: 'SEZ', name: 'Seychelles Airport', city: 'Mahé', country: 'SC' },
  { code: 'TNR', name: 'Ivato Airport', city: 'Antananarivo', country: 'MG' },
  { code: 'LAD', name: 'Luanda Airport', city: 'Luanda', country: 'AO' },
  { code: 'MPM', name: 'Maputo Airport', city: 'Maputo', country: 'MZ' },
  { code: 'WDH', name: 'Hosea Kutako', city: 'Windhoek', country: 'NA' },
  { code: 'VFA', name: 'Victoria Falls', city: 'Victoria Falls', country: 'ZW' },
  { code: 'HRE', name: 'Harare Airport', city: 'Harare', country: 'ZW' },
  { code: 'LUN', name: 'Kenneth Kaunda', city: 'Lusaka', country: 'ZM' },
  { code: 'LLW', name: 'Lilongwe Airport', city: 'Lilongwe', country: 'MW' },
  { code: 'GBE', name: 'Sir Seretse Khama', city: 'Gaborone', country: 'BW' },
  { code: 'DKR', name: 'Léopold Sédar Senghor', city: 'Dakar', country: 'SN' },

  // Russia & CIS
  { code: 'SVO', name: 'Sheremetyevo', city: 'Moscow', country: 'RU' },
  { code: 'DME', name: 'Domodedovo', city: 'Moscow', country: 'RU' },
  { code: 'VKO', name: 'Vnukovo', city: 'Moscow', country: 'RU' },
  { code: 'LED', name: 'Pulkovo Airport', city: 'St. Petersburg', country: 'RU' },
  { code: 'AER', name: 'Sochi Airport', city: 'Sochi', country: 'RU' },
  { code: 'KZN', name: 'Kazan Airport', city: 'Kazan', country: 'RU' },
  { code: 'SVX', name: 'Koltsovo Airport', city: 'Yekaterinburg', country: 'RU' },
  { code: 'OVB', name: 'Tolmachevo Airport', city: 'Novosibirsk', country: 'RU' },
  { code: 'KRR', name: 'Krasnodar Airport', city: 'Krasnodar', country: 'RU' },
  { code: 'ROV', name: 'Platov Airport', city: 'Rostov-on-Don', country: 'RU' },
  { code: 'UFA', name: 'Ufa Airport', city: 'Ufa', country: 'RU' },
  { code: 'KUF', name: 'Kurumoch Airport', city: 'Samara', country: 'RU' },
  { code: 'VVO', name: 'Vladivostok Airport', city: 'Vladivostok', country: 'RU' },
  { code: 'IKT', name: 'Irkutsk Airport', city: 'Irkutsk', country: 'RU' },
  { code: 'KHV', name: 'Khabarovsk Airport', city: 'Khabarovsk', country: 'RU' },
  { code: 'MRV', name: 'Mineralnye Vody', city: 'Mineralnye Vody', country: 'RU' },
  { code: 'GYD', name: 'Heydar Aliyev', city: 'Baku', country: 'AZ' },
  { code: 'TBS', name: 'Tbilisi Airport', city: 'Tbilisi', country: 'GE' },
  { code: 'BUS', name: 'Batumi Airport', city: 'Batumi', country: 'GE' },
  { code: 'KUT', name: 'Kutaisi Airport', city: 'Kutaisi', country: 'GE' },
  { code: 'EVN', name: 'Zvartnots Airport', city: 'Yerevan', country: 'AM' },
  { code: 'ALA', name: 'Almaty Airport', city: 'Almaty', country: 'KZ' },
  { code: 'NQZ', name: 'Astana Airport', city: 'Astana', country: 'KZ' },
  { code: 'CIT', name: 'Shymkent Airport', city: 'Shymkent', country: 'KZ' },
  { code: 'TAS', name: 'Tashkent Airport', city: 'Tashkent', country: 'UZ' },
  { code: 'SKD', name: 'Samarkand Airport', city: 'Samarkand', country: 'UZ' },
  { code: 'BHK', name: 'Bukhara Airport', city: 'Bukhara', country: 'UZ' },
  { code: 'FRU', name: 'Manas Airport', city: 'Bishkek', country: 'KG' },
  { code: 'OSS', name: 'Osh Airport', city: 'Osh', country: 'KG' },
  { code: 'DYU', name: 'Dushanbe Airport', city: 'Dushanbe', country: 'TJ' },
  { code: 'ASB', name: 'Ashgabat Airport', city: 'Ashgabat', country: 'TM' },
  { code: 'GYD', name: 'Heydar Aliyev', city: 'Baku', country: 'AZ' },

  // Asia - East
  { code: 'NRT', name: 'Narita Airport', city: 'Tokyo', country: 'JP' },
  { code: 'HND', name: 'Haneda Airport', city: 'Tokyo', country: 'JP' },
  { code: 'KIX', name: 'Kansai Airport', city: 'Osaka', country: 'JP' },
  { code: 'ITM', name: 'Itami Airport', city: 'Osaka', country: 'JP' },
  { code: 'NGO', name: 'Chubu Centrair', city: 'Nagoya', country: 'JP' },
  { code: 'CTS', name: 'New Chitose', city: 'Sapporo', country: 'JP' },
  { code: 'FUK', name: 'Fukuoka Airport', city: 'Fukuoka', country: 'JP' },
  { code: 'OKA', name: 'Naha Airport', city: 'Okinawa', country: 'JP' },
  { code: 'ICN', name: 'Incheon Airport', city: 'Seoul', country: 'KR' },
  { code: 'GMP', name: 'Gimpo Airport', city: 'Seoul', country: 'KR' },
  { code: 'PUS', name: 'Gimhae Airport', city: 'Busan', country: 'KR' },
  { code: 'CJU', name: 'Jeju Airport', city: 'Jeju', country: 'KR' },
  { code: 'PEK', name: 'Beijing Capital', city: 'Beijing', country: 'CN' },
  { code: 'PKX', name: 'Daxing Airport', city: 'Beijing', country: 'CN' },
  { code: 'PVG', name: 'Pudong Airport', city: 'Shanghai', country: 'CN' },
  { code: 'SHA', name: 'Hongqiao Airport', city: 'Shanghai', country: 'CN' },
  { code: 'CAN', name: 'Baiyun Airport', city: 'Guangzhou', country: 'CN' },
  { code: 'SZX', name: 'Bao\'an Airport', city: 'Shenzhen', country: 'CN' },
  { code: 'CTU', name: 'Shuangliu Airport', city: 'Chengdu', country: 'CN' },
  { code: 'CKG', name: 'Jiangbei Airport', city: 'Chongqing', country: 'CN' },
  { code: 'XIY', name: 'Xianyang Airport', city: 'Xi\'an', country: 'CN' },
  { code: 'HGH', name: 'Xiaoshan Airport', city: 'Hangzhou', country: 'CN' },
  { code: 'NKG', name: 'Lukou Airport', city: 'Nanjing', country: 'CN' },
  { code: 'WUH', name: 'Tianhe Airport', city: 'Wuhan', country: 'CN' },
  { code: 'XMN', name: 'Gaoqi Airport', city: 'Xiamen', country: 'CN' },
  { code: 'KMG', name: 'Changshui Airport', city: 'Kunming', country: 'CN' },
  { code: 'CSX', name: 'Huanghua Airport', city: 'Changsha', country: 'CN' },
  { code: 'TAO', name: 'Liuting Airport', city: 'Qingdao', country: 'CN' },
  { code: 'DLC', name: 'Zhoushuizi Airport', city: 'Dalian', country: 'CN' },
  { code: 'SYX', name: 'Phoenix Airport', city: 'Sanya', country: 'CN' },
  { code: 'HAK', name: 'Meilan Airport', city: 'Haikou', country: 'CN' },
  { code: 'HKG', name: 'Hong Kong Airport', city: 'Hong Kong', country: 'HK' },
  { code: 'MFM', name: 'Macau Airport', city: 'Macau', country: 'MO' },
  { code: 'TPE', name: 'Taoyuan Airport', city: 'Taipei', country: 'TW' },
  { code: 'TSA', name: 'Songshan Airport', city: 'Taipei', country: 'TW' },
  { code: 'KHH', name: 'Kaohsiung Airport', city: 'Kaohsiung', country: 'TW' },
  { code: 'ULN', name: 'Chinggis Khaan', city: 'Ulaanbaatar', country: 'MN' },

  // Asia - Southeast
  { code: 'SIN', name: 'Changi Airport', city: 'Singapore', country: 'SG' },
  { code: 'BKK', name: 'Suvarnabhumi Airport', city: 'Bangkok', country: 'TH' },
  { code: 'DMK', name: 'Don Mueang Airport', city: 'Bangkok', country: 'TH' },
  { code: 'HKT', name: 'Phuket Airport', city: 'Phuket', country: 'TH' },
  { code: 'CNX', name: 'Chiang Mai Airport', city: 'Chiang Mai', country: 'TH' },
  { code: 'KBV', name: 'Krabi Airport', city: 'Krabi', country: 'TH' },
  { code: 'USM', name: 'Samui Airport', city: 'Koh Samui', country: 'TH' },
  { code: 'CEI', name: 'Chiang Rai Airport', city: 'Chiang Rai', country: 'TH' },
  { code: 'KUL', name: 'Kuala Lumpur Airport', city: 'Kuala Lumpur', country: 'MY' },
  { code: 'SZB', name: 'Sultan Abdul Aziz Shah', city: 'Kuala Lumpur', country: 'MY' },
  { code: 'PEN', name: 'Penang Airport', city: 'Penang', country: 'MY' },
  { code: 'LGK', name: 'Langkawi Airport', city: 'Langkawi', country: 'MY' },
  { code: 'BKI', name: 'Kota Kinabalu', city: 'Kota Kinabalu', country: 'MY' },
  { code: 'KCH', name: 'Kuching Airport', city: 'Kuching', country: 'MY' },
  { code: 'CGK', name: 'Soekarno-Hatta', city: 'Jakarta', country: 'ID' },
  { code: 'DPS', name: 'Ngurah Rai Airport', city: 'Bali', country: 'ID' },
  { code: 'SUB', name: 'Juanda Airport', city: 'Surabaya', country: 'ID' },
  { code: 'UPG', name: 'Sultan Hasanuddin', city: 'Makassar', country: 'ID' },
  { code: 'JOG', name: 'Adisucipto Airport', city: 'Yogyakarta', country: 'ID' },
  { code: 'MES', name: 'Kualanamu Airport', city: 'Medan', country: 'ID' },
  { code: 'PDG', name: 'Minangkabau Airport', city: 'Padang', country: 'ID' },
  { code: 'PLM', name: 'Sultan Mahmud Badaruddin', city: 'Palembang', country: 'ID' },
  { code: 'BPN', name: 'Sultan Aji Muhammad', city: 'Balikpapan', country: 'ID' },
  { code: 'LOP', name: 'Lombok Airport', city: 'Lombok', country: 'ID' },
  { code: 'MNL', name: 'Ninoy Aquino Airport', city: 'Manila', country: 'PH' },
  { code: 'CEB', name: 'Mactan-Cebu', city: 'Cebu', country: 'PH' },
  { code: 'DVO', name: 'Davao Airport', city: 'Davao', country: 'PH' },
  { code: 'CRK', name: 'Clark Airport', city: 'Clark', country: 'PH' },
  { code: 'ILO', name: 'Iloilo Airport', city: 'Iloilo', country: 'PH' },
  { code: 'KLO', name: 'Kalibo Airport', city: 'Kalibo', country: 'PH' },
  { code: 'SGN', name: 'Tan Son Nhat', city: 'Ho Chi Minh', country: 'VN' },
  { code: 'HAN', name: 'Noi Bai Airport', city: 'Hanoi', country: 'VN' },
  { code: 'DAD', name: 'Da Nang Airport', city: 'Da Nang', country: 'VN' },
  { code: 'CXR', name: 'Cam Ranh Airport', city: 'Nha Trang', country: 'VN' },
  { code: 'PQC', name: 'Phu Quoc Airport', city: 'Phu Quoc', country: 'VN' },
  { code: 'VDO', name: 'Van Don Airport', city: 'Quang Ninh', country: 'VN' },
  { code: 'PNH', name: 'Phnom Penh Airport', city: 'Phnom Penh', country: 'KH' },
  { code: 'REP', name: 'Siem Reap Airport', city: 'Siem Reap', country: 'KH' },
  { code: 'VTE', name: 'Wattay Airport', city: 'Vientiane', country: 'LA' },
  { code: 'LPQ', name: 'Luang Prabang', city: 'Luang Prabang', country: 'LA' },
  { code: 'RGN', name: 'Yangon Airport', city: 'Yangon', country: 'MM' },
  { code: 'MDL', name: 'Mandalay Airport', city: 'Mandalay', country: 'MM' },
  { code: 'BWN', name: 'Brunei Airport', city: 'Bandar Seri Begawan', country: 'BN' },

  // Asia - South
  { code: 'DEL', name: 'Indira Gandhi Airport', city: 'Delhi', country: 'IN' },
  { code: 'BOM', name: 'Chhatrapati Shivaji', city: 'Mumbai', country: 'IN' },
  { code: 'BLR', name: 'Kempegowda Airport', city: 'Bangalore', country: 'IN' },
  { code: 'MAA', name: 'Chennai Airport', city: 'Chennai', country: 'IN' },
  { code: 'CCU', name: 'Netaji Subhas Chandra', city: 'Kolkata', country: 'IN' },
  { code: 'HYD', name: 'Rajiv Gandhi Airport', city: 'Hyderabad', country: 'IN' },
  { code: 'COK', name: 'Cochin Airport', city: 'Kochi', country: 'IN' },
  { code: 'PNQ', name: 'Pune Airport', city: 'Pune', country: 'IN' },
  { code: 'AMD', name: 'Ahmedabad Airport', city: 'Ahmedabad', country: 'IN' },
  { code: 'GOI', name: 'Goa Airport', city: 'Goa', country: 'IN' },
  { code: 'JAI', name: 'Jaipur Airport', city: 'Jaipur', country: 'IN' },
  { code: 'LKO', name: 'Lucknow Airport', city: 'Lucknow', country: 'IN' },
  { code: 'TRV', name: 'Trivandrum Airport', city: 'Thiruvananthapuram', country: 'IN' },
  { code: 'GAU', name: 'Guwahati Airport', city: 'Guwahati', country: 'IN' },
  { code: 'IXC', name: 'Chandigarh Airport', city: 'Chandigarh', country: 'IN' },
  { code: 'SXR', name: 'Srinagar Airport', city: 'Srinagar', country: 'IN' },
  { code: 'VNS', name: 'Varanasi Airport', city: 'Varanasi', country: 'IN' },
  { code: 'CMB', name: 'Bandaranaike Airport', city: 'Colombo', country: 'LK' },
  { code: 'HRI', name: 'Mattala Airport', city: 'Hambantota', country: 'LK' },
  { code: 'DAC', name: 'Hazrat Shahjalal', city: 'Dhaka', country: 'BD' },
  { code: 'CGP', name: 'Shah Amanat Airport', city: 'Chittagong', country: 'BD' },
  { code: 'KTM', name: 'Tribhuvan Airport', city: 'Kathmandu', country: 'NP' },
  { code: 'ISB', name: 'Islamabad Airport', city: 'Islamabad', country: 'PK' },
  { code: 'KHI', name: 'Jinnah Airport', city: 'Karachi', country: 'PK' },
  { code: 'LHE', name: 'Allama Iqbal Airport', city: 'Lahore', country: 'PK' },
  { code: 'MLE', name: 'Velana Airport', city: 'Malé', country: 'MV' },
  { code: 'KBL', name: 'Kabul Airport', city: 'Kabul', country: 'AF' },

  // Americas - North
  { code: 'JFK', name: 'John F. Kennedy', city: 'New York', country: 'US' },
  { code: 'EWR', name: 'Newark Airport', city: 'Newark', country: 'US' },
  { code: 'LGA', name: 'LaGuardia Airport', city: 'New York', country: 'US' },
  { code: 'LAX', name: 'Los Angeles Airport', city: 'Los Angeles', country: 'US' },
  { code: 'ORD', name: 'O\'Hare Airport', city: 'Chicago', country: 'US' },
  { code: 'MDW', name: 'Midway Airport', city: 'Chicago', country: 'US' },
  { code: 'MIA', name: 'Miami Airport', city: 'Miami', country: 'US' },
  { code: 'FLL', name: 'Fort Lauderdale', city: 'Fort Lauderdale', country: 'US' },
  { code: 'SFO', name: 'San Francisco Airport', city: 'San Francisco', country: 'US' },
  { code: 'OAK', name: 'Oakland Airport', city: 'Oakland', country: 'US' },
  { code: 'SJC', name: 'San Jose Airport', city: 'San Jose', country: 'US' },
  { code: 'ATL', name: 'Hartsfield-Jackson', city: 'Atlanta', country: 'US' },
  { code: 'DFW', name: 'Dallas/Fort Worth', city: 'Dallas', country: 'US' },
  { code: 'IAH', name: 'George Bush Airport', city: 'Houston', country: 'US' },
  { code: 'HOU', name: 'Hobby Airport', city: 'Houston', country: 'US' },
  { code: 'BOS', name: 'Logan Airport', city: 'Boston', country: 'US' },
  { code: 'SEA', name: 'Seattle-Tacoma', city: 'Seattle', country: 'US' },
  { code: 'LAS', name: 'Harry Reid Airport', city: 'Las Vegas', country: 'US' },
  { code: 'DEN', name: 'Denver Airport', city: 'Denver', country: 'US' },
  { code: 'PHX', name: 'Phoenix Sky Harbor', city: 'Phoenix', country: 'US' },
  { code: 'PHL', name: 'Philadelphia Airport', city: 'Philadelphia', country: 'US' },
  { code: 'MSP', name: 'Minneapolis-St Paul', city: 'Minneapolis', country: 'US' },
  { code: 'DTW', name: 'Detroit Metro', city: 'Detroit', country: 'US' },
  { code: 'CLT', name: 'Charlotte Douglas', city: 'Charlotte', country: 'US' },
  { code: 'MCO', name: 'Orlando Airport', city: 'Orlando', country: 'US' },
  { code: 'TPA', name: 'Tampa Airport', city: 'Tampa', country: 'US' },
  { code: 'DCA', name: 'Reagan National', city: 'Washington DC', country: 'US' },
  { code: 'IAD', name: 'Dulles Airport', city: 'Washington DC', country: 'US' },
  { code: 'BWI', name: 'Baltimore-Washington', city: 'Baltimore', country: 'US' },
  { code: 'SLC', name: 'Salt Lake City', city: 'Salt Lake City', country: 'US' },
  { code: 'SAN', name: 'San Diego Airport', city: 'San Diego', country: 'US' },
  { code: 'PDX', name: 'Portland Airport', city: 'Portland', country: 'US' },
  { code: 'HNL', name: 'Honolulu Airport', city: 'Honolulu', country: 'US' },
  { code: 'ANC', name: 'Anchorage Airport', city: 'Anchorage', country: 'US' },
  { code: 'YYZ', name: 'Pearson Airport', city: 'Toronto', country: 'CA' },
  { code: 'YYC', name: 'Calgary Airport', city: 'Calgary', country: 'CA' },
  { code: 'YVR', name: 'Vancouver Airport', city: 'Vancouver', country: 'CA' },
  { code: 'YUL', name: 'Trudeau Airport', city: 'Montreal', country: 'CA' },
  { code: 'YOW', name: 'Ottawa Airport', city: 'Ottawa', country: 'CA' },
  { code: 'YEG', name: 'Edmonton Airport', city: 'Edmonton', country: 'CA' },
  { code: 'YWG', name: 'Winnipeg Airport', city: 'Winnipeg', country: 'CA' },
  { code: 'YHZ', name: 'Halifax Airport', city: 'Halifax', country: 'CA' },
  { code: 'YQB', name: 'Quebec City Airport', city: 'Quebec City', country: 'CA' },
  { code: 'MEX', name: 'Benito Juárez', city: 'Mexico City', country: 'MX' },
  { code: 'CUN', name: 'Cancún Airport', city: 'Cancún', country: 'MX' },
  { code: 'GDL', name: 'Guadalajara Airport', city: 'Guadalajara', country: 'MX' },
  { code: 'MTY', name: 'Monterrey Airport', city: 'Monterrey', country: 'MX' },
  { code: 'TIJ', name: 'Tijuana Airport', city: 'Tijuana', country: 'MX' },
  { code: 'SJD', name: 'Los Cabos Airport', city: 'San José del Cabo', country: 'MX' },
  { code: 'PVR', name: 'Puerto Vallarta', city: 'Puerto Vallarta', country: 'MX' },

  // Americas - Central & Caribbean
  { code: 'PTY', name: 'Tocumen Airport', city: 'Panama City', country: 'PA' },
  { code: 'SJO', name: 'Juan Santamaría', city: 'San José', country: 'CR' },
  { code: 'GUA', name: 'La Aurora Airport', city: 'Guatemala City', country: 'GT' },
  { code: 'SAL', name: 'El Salvador Airport', city: 'San Salvador', country: 'SV' },
  { code: 'TGU', name: 'Toncontín Airport', city: 'Tegucigalpa', country: 'HN' },
  { code: 'MGA', name: 'Managua Airport', city: 'Managua', country: 'NI' },
  { code: 'BZE', name: 'Belize City Airport', city: 'Belize City', country: 'BZ' },
  { code: 'HAV', name: 'José Martí Airport', city: 'Havana', country: 'CU' },
  { code: 'VRA', name: 'Varadero Airport', city: 'Varadero', country: 'CU' },
  { code: 'NAS', name: 'Nassau Airport', city: 'Nassau', country: 'BS' },
  { code: 'MBJ', name: 'Montego Bay', city: 'Montego Bay', country: 'JM' },
  { code: 'KIN', name: 'Norman Manley', city: 'Kingston', country: 'JM' },
  { code: 'PUJ', name: 'Punta Cana Airport', city: 'Punta Cana', country: 'DO' },
  { code: 'SDQ', name: 'Las Américas', city: 'Santo Domingo', country: 'DO' },
  { code: 'SJU', name: 'Luis Muñoz Marín', city: 'San Juan', country: 'PR' },
  { code: 'AUA', name: 'Queen Beatrix', city: 'Oranjestad', country: 'AW' },
  { code: 'CUR', name: 'Hato Airport', city: 'Willemstad', country: 'CW' },
  { code: 'SXM', name: 'Princess Juliana', city: 'Sint Maarten', country: 'SX' },
  { code: 'POS', name: 'Piarco Airport', city: 'Port of Spain', country: 'TT' },
  { code: 'BGI', name: 'Grantley Adams', city: 'Bridgetown', country: 'BB' },

  // Americas - South
  { code: 'GRU', name: 'Guarulhos Airport', city: 'São Paulo', country: 'BR' },
  { code: 'CGH', name: 'Congonhas Airport', city: 'São Paulo', country: 'BR' },
  { code: 'VCP', name: 'Viracopos Airport', city: 'Campinas', country: 'BR' },
  { code: 'GIG', name: 'Galeão Airport', city: 'Rio de Janeiro', country: 'BR' },
  { code: 'SDU', name: 'Santos Dumont', city: 'Rio de Janeiro', country: 'BR' },
  { code: 'BSB', name: 'Brasília Airport', city: 'Brasília', country: 'BR' },
  { code: 'CNF', name: 'Confins Airport', city: 'Belo Horizonte', country: 'BR' },
  { code: 'SSA', name: 'Salvador Airport', city: 'Salvador', country: 'BR' },
  { code: 'REC', name: 'Recife Airport', city: 'Recife', country: 'BR' },
  { code: 'FOR', name: 'Fortaleza Airport', city: 'Fortaleza', country: 'BR' },
  { code: 'POA', name: 'Porto Alegre Airport', city: 'Porto Alegre', country: 'BR' },
  { code: 'CWB', name: 'Curitiba Airport', city: 'Curitiba', country: 'BR' },
  { code: 'FLN', name: 'Florianópolis Airport', city: 'Florianópolis', country: 'BR' },
  { code: 'NAT', name: 'Natal Airport', city: 'Natal', country: 'BR' },
  { code: 'MAO', name: 'Manaus Airport', city: 'Manaus', country: 'BR' },
  { code: 'BEL', name: 'Belém Airport', city: 'Belém', country: 'BR' },
  { code: 'EZE', name: 'Ezeiza Airport', city: 'Buenos Aires', country: 'AR' },
  { code: 'AEP', name: 'Aeroparque Airport', city: 'Buenos Aires', country: 'AR' },
  { code: 'COR', name: 'Córdoba Airport', city: 'Córdoba', country: 'AR' },
  { code: 'MDZ', name: 'Mendoza Airport', city: 'Mendoza', country: 'AR' },
  { code: 'BRC', name: 'Bariloche Airport', city: 'Bariloche', country: 'AR' },
  { code: 'USH', name: 'Ushuaia Airport', city: 'Ushuaia', country: 'AR' },
  { code: 'IGR', name: 'Iguazú Airport', city: 'Puerto Iguazú', country: 'AR' },
  { code: 'SCL', name: 'Arturo Merino Benítez', city: 'Santiago', country: 'CL' },
  { code: 'IPC', name: 'Mataveri Airport', city: 'Easter Island', country: 'CL' },
  { code: 'PUQ', name: 'Punta Arenas Airport', city: 'Punta Arenas', country: 'CL' },
  { code: 'BOG', name: 'El Dorado Airport', city: 'Bogotá', country: 'CO' },
  { code: 'MDE', name: 'José María Córdova', city: 'Medellín', country: 'CO' },
  { code: 'CTG', name: 'Rafael Núñez', city: 'Cartagena', country: 'CO' },
  { code: 'CLO', name: 'Alfonso Bonilla Aragón', city: 'Cali', country: 'CO' },
  { code: 'BAQ', name: 'Ernesto Cortissoz', city: 'Barranquilla', country: 'CO' },
  { code: 'LIM', name: 'Jorge Chávez Airport', city: 'Lima', country: 'PE' },
  { code: 'CUZ', name: 'Alejandro Velasco', city: 'Cusco', country: 'PE' },
  { code: 'UIO', name: 'Mariscal Sucre', city: 'Quito', country: 'EC' },
  { code: 'GYE', name: 'José Joaquín de Olmedo', city: 'Guayaquil', country: 'EC' },
  { code: 'GPS', name: 'Galápagos Airport', city: 'Baltra', country: 'EC' },
  { code: 'CCS', name: 'Simón Bolívar', city: 'Caracas', country: 'VE' },
  { code: 'LPB', name: 'El Alto Airport', city: 'La Paz', country: 'BO' },
  { code: 'VVI', name: 'Viru Viru Airport', city: 'Santa Cruz', country: 'BO' },
  { code: 'ASU', name: 'Silvio Pettirossi', city: 'Asunción', country: 'PY' },
  { code: 'MVD', name: 'Carrasco Airport', city: 'Montevideo', country: 'UY' },
  { code: 'GEO', name: 'Cheddi Jagan', city: 'Georgetown', country: 'GY' },
  { code: 'PBM', name: 'Zanderij Airport', city: 'Paramaribo', country: 'SR' },
  { code: 'CAY', name: 'Cayenne Airport', city: 'Cayenne', country: 'GF' },

  // Oceania
  { code: 'SYD', name: 'Sydney Airport', city: 'Sydney', country: 'AU' },
  { code: 'MEL', name: 'Melbourne Airport', city: 'Melbourne', country: 'AU' },
  { code: 'BNE', name: 'Brisbane Airport', city: 'Brisbane', country: 'AU' },
  { code: 'PER', name: 'Perth Airport', city: 'Perth', country: 'AU' },
  { code: 'ADL', name: 'Adelaide Airport', city: 'Adelaide', country: 'AU' },
  { code: 'OOL', name: 'Gold Coast Airport', city: 'Gold Coast', country: 'AU' },
  { code: 'CNS', name: 'Cairns Airport', city: 'Cairns', country: 'AU' },
  { code: 'CBR', name: 'Canberra Airport', city: 'Canberra', country: 'AU' },
  { code: 'HBA', name: 'Hobart Airport', city: 'Hobart', country: 'AU' },
  { code: 'DRW', name: 'Darwin Airport', city: 'Darwin', country: 'AU' },
  { code: 'AKL', name: 'Auckland Airport', city: 'Auckland', country: 'NZ' },
  { code: 'WLG', name: 'Wellington Airport', city: 'Wellington', country: 'NZ' },
  { code: 'CHC', name: 'Christchurch Airport', city: 'Christchurch', country: 'NZ' },
  { code: 'ZQN', name: 'Queenstown Airport', city: 'Queenstown', country: 'NZ' },
  { code: 'DUD', name: 'Dunedin Airport', city: 'Dunedin', country: 'NZ' },
  { code: 'NAN', name: 'Nadi Airport', city: 'Nadi', country: 'FJ' },
  { code: 'PPT', name: 'Faa\'a Airport', city: 'Papeete', country: 'PF' },
  { code: 'NOU', name: 'La Tontouta', city: 'Nouméa', country: 'NC' },
  { code: 'APW', name: 'Faleolo Airport', city: 'Apia', country: 'WS' },
  { code: 'TBU', name: 'Fua\'amotu Airport', city: 'Nukuʻalofa', country: 'TO' },
  { code: 'VLI', name: 'Port Vila Airport', city: 'Port Vila', country: 'VU' },
  { code: 'GUM', name: 'Guam Airport', city: 'Hagåtña', country: 'GU' },
  { code: 'POM', name: 'Jacksons Airport', city: 'Port Moresby', country: 'PG' },
];

// Helper function to search airports
export function searchAirports(query: string, limit = 20): Airport[] {
  if (!query || query.length < 2) return [];

  const q = query.toLowerCase();
  return AIRPORTS
    .filter(airport =>
      airport.code.toLowerCase().includes(q) ||
      airport.name.toLowerCase().includes(q) ||
      airport.city.toLowerCase().includes(q)
    )
    .slice(0, limit);
}

// Helper function to get airport by code
export function getAirportByCode(code: string): Airport | undefined {
  return AIRPORTS.find(a => a.code === code);
}

// Format airport for display
export function formatAirport(airport: Airport): string {
  return `${airport.code} - ${airport.city}`;
}

export function formatAirportFull(airport: Airport): string {
  return `${airport.code} - ${airport.name}, ${airport.city}`;
}
